// extracted by mini-css-extract-plugin
module.exports = {"logo":"logo-with-text_logo__kyZRn","name":"logo-with-text_name___SXa5","logoIcon":"logo-with-text_logoIcon__3m7_O"};